'use es6';

import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_PROMPT = createAsyncActionTypes('FETCH_PROMPT');
export const DISMISS_PROMPT = createAsyncActionTypes('DISMISS_PROMPT');
export const PROMPT_WAS_SHOWN = createAsyncActionTypes('PROMPT_WAS_SHOWN');